import { createFileRoute } from '@tanstack/react-router';
import { Typography, Paper } from '@mui/material';

export const Route = createFileRoute('/__auth/signatures/$id/documents')({
    component: EnvelopeDocumentsRoute,
});

function EnvelopeDocumentsRoute() {
    return (
        <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>Documentos Anexados</Typography>
            <Typography variant="body2" color="text.secondary">A lista de documentos será implementada em seguida.</Typography>
        </Paper>
    );
}
